<template>
  <div class="row">
    <div class="col-6">

    <form class="col-sm-10 p-4">
      <div class="form-group col-sm-12 mb-sm-0 h6">
        <label class="font-weight-bold">Candidate Name:</label>
        <label>{{ fullName(candidate) }}</label>
      </div>

      <div class="form-group col-sm-12 mb-sm-0 h6">
        <label class="font-weight-bold">Date of Birth:</label>
        <label>{{ candidate.date_of_birth }}</label>
      </div>

      <div class="form-group col-sm-12 mb-sm-0 h6" v-if="applicantSearch.currentAddress">
        <label class="font-weight-bold">Address:</label>
        <label>{{ applicantSearch.currentAddress.address }}</label>
      </div>
      <hr>
    </form>
    </div>
    <div class="col-6">
      <div class="form-group col-sm-12 mb-sm-0 h6" v-if="applicantSearch.socialMediaChecks && applicantSearch.socialMediaChecks.length">
        <label class="font-weight-bold">Social Media Checks:</label>
        <div v-for="check in applicantSearch.socialMediaChecks" :key="check.id" class="mb-2">
          <p>
            <strong>Platform:</strong> {{ check.handle_name }}<br />
            <strong>Profile Link:</strong>
            <a :href="check.profile_link" target="_blank">{{ check.profile_link }}</a><br />
            <strong>Status:</strong> {{ check.status }}<br />
            <strong>Comment:</strong> {{ check.comment }}<br />
            <strong>Verified At:</strong> {{ check.verified_at }}
          </p>
        </div>
      </div>
    </div>

      <div class="col-12">
        <form
          ref="form"
          :data-url=addurl
          class="mb-sm-0"
          id="social_media_check"
          :class="{ 'loading-opacity': preloader }">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>{{ $t("select_handle_name") }}</label>
                  <app-input
                    type="search-select"
                    :placeholder="$t('select_handle_name')"
                    :list="handleList"
                    v-model="inputs.handle_name"
                    :required="true"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>{{ $t("exist") }}</label>
                  <app-input
                    type="radio"
                    :list="list"
                    v-model="inputs.exist"
                    :required="true"
                  />
                </div>
              </div>
              <div class="col-12" v-if="inputs.exist == 1">
                <div class="form-group">
                  <label for="inputs_profile_link">
                    {{ $t("profile_link") }}
                  </label>
                  <app-input
                    id="inputs_profile_link"
                    type="text"
                    v-model="inputs.profile_link"
                    :required="true"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="inputs_comment" >
                    {{ $t("comment") }}
                  </label>
                  <app-input
                    id="inputs_comment"
                    type="textarea"
                    v-model="inputs.comment"
                    :required="true"
                  />
                </div>
              </div>
              <div class="form-group col-sm-12">

                <label for="Date">Select Date</label>
                <app-input
                    type="date"
                    v-model="inputs.verified_at"
                />
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>{{ $t("select_status") }}</label>
                  <app-input
                    type="select"
                    :placeholder="$t('select_status')"
                    :list="statusList"
                    v-model="inputs.status"
                    :required="true"
                  />
                </div>
              </div>
              <div class="col-6 mt-5 action-buttons">
                <button
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="submitData"
                >
                  {{ $t("submit") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-secondary"
                  @click.prevent="clear"
                >
                  {{ $t("clear") }}
                </button>
              </div>
            </div>
        </form>
      </div>

  </div>
</template>

<script>
import { APPLICANT_SOCIAL_MEDIA_CHECK } from "@/app/Config/ScreeningAppUrl";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {fullName} from "@Views/Screening/utility/common";

export default {
  name: "SocialMediaCheck",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      applicantSearch: this.$attrs['props'].applicantSearch,
      candidate: this.$attrs['props'].candidate,
      currentAddress: this.$attrs['props'].currentAddress??{},

      addurl: APPLICANT_SOCIAL_MEDIA_CHECK,
      inputs: {
        exist: "1",
      },
      handleList: [
          { id: "facebook", value: "Facebook" },
          { id: "instagram", value: "Instagram" },
          { id: "whatsapp", value: "WhatsApp" },
          { id: "youtube", value: "YouTube" },
          { id: "tiktok", value: "TikTok" },
          { id: "snapchat", value: "Snapchat" },
          { id: "x", value: "X (formerly Twitter)" },
          { id: "pinterest", value: "Pinterest" },
          { id: "reddit", value: "Reddit" },
          { id: "linkedin", value: "LinkedIn" }
        ],
      list: [
        {id: "1",value: "Yes"},
        {id: "0",value: "No"},
      ],
      statusList: [
        {id: "",value: "Select Status"},
        {id: "pending",value: "Pending"},
        {id: "complete",value: "Complete"},
      ]
    }
  },
  methods: {
    fullName,
    beforeSubmit() {
      this.preloader = true;
    },
    submitData() {
      this.inputs.applicant_id = this.candidate.id;
      this.save(this.inputs);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      // this.onAddCheck();
      try {
        this.$attrs['props'].onAddCheck('socialMediaChecks', res.data.data)
      } catch (e) {
        console.error(e)
      }
      this.preloader = false;
      this.clear();
    },
    afterError(res) {
      console.error(res)
    },
    clear() {
      this.inputs = {
        exist: "1",
      }
    },
  }
}
</script>